const PRODUCT_ERRORS = {
  CUSTOMIZE_COMMAS_NOT_ALLOWED: 'Commas are not allowed in customise fields',
  IDENTICAL_INSTRUCTIONS_NOT_ALLOWED: 'Identical instructions detected, please provide unique instructions for each customise field',
  DESCRIPTION_REQUIRED: 'Please add a description',
}

export default PRODUCT_ERRORS;
